export default __webpack_public_path__ + "static/media/gallery-wip-control-box_04.a9c94e5d.jpg";